import { render } from "./Welcome.vue?vue&type=template&id=15c03783&lang=pug"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=15c03783&lang=scss"
script.render = render

export default script